export enum CharterStatus {
  WaitingPayment = 'WAITING_FOR_PAYMENT',
  WaitingApproval = 'WAITING_FOR_APPROVAL',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED',
  Archived = 'PENDING',
  Booked = 'BOOKED'
}
